import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/payment")({
  head: () => ({ meta: [{ title: "Payment Settings | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-payment")),
});
